export class User {
    id?: string;
    full_name: string;
    first_name: string;
    last_name: string;
    initials?: string;
    primary_contact?: string;
    user_id?: string;
    email?: string;
    full_str?: string;
    country_code?: string;
    country_name?: string;
    icon_url?: string;
    icon_url_small?: string;
    role?: string;
    roles?: any;
    displayRole?: string;
    isVisible?: boolean;
    selected?: boolean;
    invitation_code?: string;
    type?: string;
    activated?: boolean;
    tenant_id?: string;
    user_hash?: string;
    name_id?: string;
    user_color: string;
    session_index?: string;
    agency?: string;
    profile_image?: string;
    status?: string;
    actions?: any[];
    favoriteVonqProducts?: string[];
}
